import backToTop from './modules/back-to-top';
import isi from './modules/isi';
import heroVideo from './modules/hero-video';
import homepageAnimation from './modules/homepage-animation';

$(document).ready(function () {

  // allow Efficacy (parent) to be clickable in nav
  $('.dropdown > a span').on('click', function (e) {
    e.stopPropagation();
    window.location = 'efficacy';
  });

  // load ISI
  isi();

  // load back-to-top btn
  backToTop();

  // load homepage hero video
  heroVideo();

  // initiate homepage animation
  homepageAnimation();

});


// WEBPACK FOOTER //
// ./js/main.js